<template>
  <div>
    <v-app-bar
      v-if="this.$route.name == 'frontendPackages'"
      height="80px"
      app
      color="white"
      dark
    >
      <v-row justify="center" align="center">
        <v-col class="text-left py-0" cols="9" sm="9" md="2" lg="2" >
          <v-img
            alt="Vuetify Logo"
            :src="this.$store.state.agency.agencyLogo"
            transition="scale-transition"
            height="35px"
            width="200px"
          />
        </v-col>
        <v-col cols="8" class="hidden-md-and-down">
          <a href="https://compeat.social/" class="mx-1 menuitems"> Home </a>
          <a href="https://compeat.social/why-use-compeat/" class="mx-1 menuitems"> Why Use Compeat </a>
          <a href="https://compeat.social/compeat-for-agencies/" class="mx-1 menuitems"> Compeat For Agencies </a>
          <a href="https://compeat.social/packages/" class="mx-1 menuitems"> Packages </a>
          <!-- <a href="#" class="mx-1 menuitems"> Reports </a> -->
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <a class="mx-1 menuitems" 
                v-bind="attrs"
                v-on="on"
                > Reports
                <v-icon class="arrowDown" small>
                  mdi-chevron-down
                </v-icon>
              </a>

              <!-- <v-btn
                color="primary"
                dark
                v-bind="attrs"
                v-on="on"
              >
                Dropdown
              </v-btn> -->
            </template>
            <v-list>
              <v-list-item
              >
                <v-list-item-title>
                  <a href="https://compeat.social/social-analysis/" class="mx-1 menuitems"> Social Analytics </a> 
                </v-list-item-title>
              </v-list-item>
              <v-list-item
              >
                <v-list-item-title>
                  <a href="https://compeat.social/fb-competitive-analysis/" class="mx-1 menuitems"> FB Competitive Analytics </a> 
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          <a href="https://compeat.social/become-a-reseller/" class="mx-1 menuitems"> Become a Reseller </a>
          <a href="https://compeat.social/support-desk/" class="mx-1 menuitems"> Support Desk </a>
        </v-col>
        <v-col cols="3" sm="3" mb="2" lg="2" class="text-right py-0">
          <v-btn
            class="compeatsecondary hidden-md-and-down packagesButton"
            href="https://compeat.social/packages/"
            target="_blank"
            small
          >
            <v-icon small class="mr-1">mdi-arrow-left-bold-circle</v-icon>
            Packages
          </v-btn>
          <v-btn
            class="compeatsecondary hidden-md-and-up packagesButton"
            href="https://compeat.social/packages/"
            target="_blank"
          >
            <v-icon small class="mr-1">mdi-arrow-left-bold-circle</v-icon>
            Back
          </v-btn>
        </v-col>
      </v-row>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  data: () =>({
    selectedItem: 1,
      items: [
        { text: 'Real-Time', icon: 'mdi-clock' },
        { text: 'Audience', icon: 'mdi-account' },
        { text: 'Conversions', icon: 'mdi-flag' },
      ],
  })
}
</script>

<style>
/* .v-toolbar__content,
.v-toolbar__extension {
  height: 80px !important;
}

.packagesButton {
  box-shadow: 10px 10px #65b8e8 !important;
}*/
.v-sheet.v-app-bar.v-toolbar:not(.v-sheet--outlined) {
  box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0),
    0px 4px 5px 0px rgba(0, 0, 0, 0), 0px 1px 10px 0px rgba(0, 0, 0, 0.2) !important;
} 
.packagesButton {
  box-shadow: 5px 5px #65b8e8 !important;
}

.menuitems {
  text-decoration: none !important;
  text-transform: uppercase;
  color:#757575 !important;
  font-size: 12px;
}

.arrowDown {
  color:#757575 !important;
}
</style>
